import LogicaAPI from "./logicaapi";

class Purchase extends LogicaAPI {
  async purchaseExecute({
    productId,
    paymentInstrumentId,
    voucherCode,
    // userVoucherId,
  }) {
    const params = {
      product_id: productId,
      payment_instrument_id: paymentInstrumentId,
      with_order: true,
    };

    if (voucherCode) {
      params.voucher_code = voucherCode;
    }

    // if (!!userVoucherId) {
    //   params.user_voucher_id = userVoucherId;
    // }

    console.log("args", {
      productId,
      paymentInstrumentId,
      voucherCode,
      // userVoucherId,
    });
    console.log("purchaseExecute", params);
    const res = this.post("/api/v1/purchase/execute", { body: params });
    return res;
  }

  estimate({ productId, paymentMethodId, voucherCode /*userVoucherId*/ }) {
    const params = {
      product_id: productId,
      payment_method_id: paymentMethodId,
    };

    if (voucherCode) {
      params.voucher_code = voucherCode;
    }
    // if (userVoucherId) {
    //   params.user_voucher_id = userVoucherId;
    // }
    return this.post("/api/v1/purchase/estimate", { body: params });
  }
}
export default Purchase;
